import { Feature } from "ol";
import { Geometry, Point } from "ol/geom";
import Style from "ol/style/Style";
import BaseFeature from "../base.feature";
import Icon from "ol/style/Icon";
import Text from "ol/style/Text";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import { fromLonLat } from "ol/proj";
import IBaseDataReport from "@/models/reports/base-data.report";

export default class ReportFeature extends BaseFeature {
    data: IBaseDataReport
    text: string
    icon: string
    type: string

    constructor(data: IBaseDataReport, icon: string, text: string, type: string) {
        super()
        this.data = data
        this.text = text
        this.icon = icon
        this.type = type
    }

    getFeature(): Feature<Geometry> {
        return new Feature({
            geometry: new Point(fromLonLat([this.data.longitude, this.data.latitude])), //recoge las coordenadas de ubicacion
            type: this.type,
            data: this.data,
            icon: this.icon
        })
    }

    getStyle(): Style {
        return new Style({
            image: new Icon(({
                anchor: [0.5, 1],
                scale: 0.4,
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                crossOrigin: 'anonymous',
                src: require(`@/assets/img/pointers/${this.icon}.png`)
            })),
            text: new Text({
                font: 'bold 13px Calibri',
                overflow: true,
                text: this.text,
                fill: new Fill({
                    color: '#000000'
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 2.5
                }),
                offsetY: 13,
                scale: 1.5
            })
        })
    }
    isValid(): boolean {
        return true
    }

}